import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import './TextareaField.component.scss';

export function TextareaFieldComponent(
  {
    input,
    label,
    meta: { touched, error },
    errorTrigger
  }: any,
) {
  const [trigger, setTrigger] = useState(false);
  useEffect(() => setTrigger(errorTrigger), [errorTrigger]);

  return (
    <div className='field-container textarea-container'>
      <textarea
        {...input}
        placeholder={label}
        type='textarea'
        className={
          'field ' +
          ((touched || trigger) && error ? 'field-error' : touched ? 'field-success' : '')
        }
      />
      <div className='message-container'>
        {(touched || trigger) && error && (
          <span className='field-error-message'>
            <FormattedMessage id={error.id} values={{ value: error.value }} />
          </span>
        )}
      </div>
    </div>
  );
}
